import * as yup from 'yup';

const iban_regex = process.env.REACT_APP_ENVIRONMENT !== 'UAT' ? /^SA\d{22}$/ : /^SA[A-Z0-9]{22}$/

export const individual_bank_information_schema = yup.object().shape({
  isSaudi: yup.boolean(),

  bankId: yup.object().when('isSaudi', {
    is: true,
    then: (schema) => schema.required('bank_is_required'),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),

  bankName: yup.string().when('isSaudi', {
    is: false,
    then: (schema) => schema.required('bank_is_required'),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),

  branch: yup
    .string()
    .required('branch_is_required')
    .max(100, 'max_100_character'),

  beneficiaryName: yup
    .string()
    .required('beneficiary_name_is_required')
    .max(100, 'max_100_character'),

  iban: yup
    .string()
    .required('iban_is_required')
    .when('isSaudi', {
      is: true,
      then: (schema) => schema.matches(iban_regex, 'iban_must_be_22_digits'),
      otherwise: (schema) =>
        schema.matches(
          // /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{15,34}$/,
          /^(?!SA)(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{15,34}$/,
          'iban_must_be_32_digits'
        ),
    }),

  registeredAddress: yup.string().when('isSaudi', {
    is: false,
    then: (schema) =>
      schema
        .required('registered_address_is_required')
        .max(100, 'max_100_character'),
    otherwise: (schema) => schema.notRequired(),
  }),

  abaRoutingNumber: yup.string().when('isSaudi', {
    is: false,
    then: (schema) =>
      schema
        .required('aba_routing_no_is_required')
        .max(100, 'max_100_character'),
    otherwise: (schema) => schema.notRequired(),
  }),

  swiftCode: yup.string().when('isSaudi', {
    is: false,
    then: (schema) =>
      schema
        .required('swift_code_is_required')
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/,
          'swiftcode_must_be_11_character'
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
});


